import { CREATE_MANHEIM_ACCOUNT } from '../../../constants/resources';

import {
    getContactValidationAndMessage,
    getMinLengthValidator,
    getMaxLengthValidator,
    getPasswordValidation,
    handleNotSpaceUserName,
    handleIsSpecialWordsUserName,
    notEqualsIgnoreCase,
    getPhoneValidation
} from '../../../../../shared/js/util/validationUtils';

import { CONTACT_KINDS, USER_NAME_LENGTH, NAME_LENGTH } from '../../../../../shared/js/constants';

export const getCreateNewAccountFormValidations = () => {
    const {
        validation: emailValidation,
        message: emailValidationError
    } = getContactValidationAndMessage(CONTACT_KINDS.EMAIL);

    const { minLen: usernameMinLen, message: usernameMinLenErrorMessage } = getMinLengthValidator(
        'username',
        CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD,
        USER_NAME_LENGTH.MIN
    );

    const { maxLen: usernameMaxLen, message: usernameMaxLenErrorMessage } = getMaxLengthValidator(
        'username',
        CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD,
        USER_NAME_LENGTH.MAX
    );

    const {
        validators: passwordValidation,
        errorMessages: passwordValidationErrors
    } = getPasswordValidation();

    const { minLen: firstNameMinLen, message: firstNameMinLenErrorMessage } = getMinLengthValidator(
        'firstName',
        CREATE_MANHEIM_ACCOUNT.FIRST_NAME_FIELD,
        NAME_LENGTH.MIN
    );

    const { minLen: lastNameMinLen, message: lastNameMinLenErrorMessage } = getMinLengthValidator(
        'lastName',
        CREATE_MANHEIM_ACCOUNT.LAST_NAME_FIELD,
        NAME_LENGTH.MIN
    );

    return {
        phoneValidation: {
            validations: { 
                ...getPhoneValidation().validations,
                phoneNotTaken: model => !model['userCreationErrors'] || !model['userCreationErrors'].some(e => e.property ==='phone')
            },
            validationErrors: { 
                ...getPhoneValidation().validationErrors,
                phoneNotTaken: CREATE_MANHEIM_ACCOUNT.PHONE_FIELD_ALREADY_EXISTS_ERR
            }
        },
        emailValidation: {
            validations: emailValidation,
            validationErrors: { 'isEmail': emailValidationError }
        },
        usernameValidation: {
            validations: {
                minLen: usernameMinLen,
                maxLen: usernameMaxLen,
                notSpaceUserName: model => handleNotSpaceUserName(model['username']),
                isSpecialWordsUserName: model => handleIsSpecialWordsUserName(model['username']),
                notEqualsToUserName: model => notEqualsIgnoreCase(model['email'], model['username']),
                usernameNotTaken: model => !model['userCreationErrors'] || !model['userCreationErrors'].some(e => e.property ==='username')
            },
            validationErrors: {
                minLen: usernameMinLenErrorMessage,
                maxLen: usernameMaxLenErrorMessage,
                notSpaceUserName: flex.formatString(CREATE_MANHEIM_ACCOUNT.CHECK_LENGTH_SPACE_WORDS_MSG, CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD, USER_NAME_LENGTH.MIN, USER_NAME_LENGTH.MAX),
                isSpecialWordsUserName: flex.formatString(CREATE_MANHEIM_ACCOUNT.CHECK_SPECIAL_WORDS_MSG, CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD),
                notEqualsToUserName: flex.formatString(CREATE_MANHEIM_ACCOUNT.VALUE_SAME_EMAIL_MSG, CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD, CREATE_MANHEIM_ACCOUNT.EMAIL_FIELD),
                usernameNotTaken: CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD_ALREADY_EXISTS_ERR
            }
        },
        passwordValidation: {
            validations: {
                ...passwordValidation,
                notEqualsToUserName: model => notEqualsIgnoreCase(model['password'], model['username'])
            },
            validationErrors: {
                ...passwordValidationErrors,
                notEqualsToUserName: `${CREATE_MANHEIM_ACCOUNT.PASSWORD_FIELD} cannot be the same as ${CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD}`
            }
        },
        firstNameValidation: {
            validations: { minLen: firstNameMinLen },
            validationErrors: { minLen: firstNameMinLenErrorMessage }
        },
        lastNameValidation: {
            validations: { minLen: lastNameMinLen },
            validationErrors: { minLen: lastNameMinLenErrorMessage }
        }
    };
};
